import { createFileRoute } from '@tanstack/react-router';

import { ChangelogPage } from '../features/admin/changelog/ChangelogPage';
import { changelogRouteSearchSchema } from '../features/admin/changelog/changelogRouteSearch';

export const Route = createFileRoute('/admin/changelog')({
  validateSearch: changelogRouteSearchSchema,
  component: ChangelogPage,
});
